import { useState } from 'react';
import { clsx } from 'clsx';
import { Icon } from './ui/Icon';
import { useEditor } from '@/store/editor';
import { toolSets } from '@/lib/toolSets';

export function AdaptiveToolbar() {
  const selectedObject = useEditor((s) => s.selectedObject);
  const openGenerate = useEditor((s) => s.openGenerate);
  const tools = toolSets[selectedObject];
  const [activeIdx, setActiveIdx] = useState(0);

  return (
    <aside className="bg-bg-panel border-r border-border flex flex-col items-center py-3 gap-1 w-16">
      {tools.map((tool, idx) => {
        if ('sep' in tool) {
          return <div key={`sep-${idx}`} className="w-8 h-px bg-border my-2" />;
        }
        const isActive = activeIdx === idx;
        return (
          <button
            key={`${tool.icon}-${idx}`}
            onClick={() => setActiveIdx(idx)}
            className={clsx(
              'group relative w-10 h-10 rounded-[9px] flex items-center justify-center transition-all',
              isActive
                ? 'bg-[rgba(59,130,246,0.15)] text-accent'
                : 'text-text-muted hover:bg-bg-panel-hover hover:text-text',
            )}
            title={tool.label}
          >
            <Icon name={tool.icon} size={20} />
            <span className="absolute left-[52px] top-1/2 -translate-y-1/2 translate-x-[-4px] opacity-0 group-hover:opacity-100 group-hover:translate-x-0 transition-all bg-bg-elevated border border-border-strong px-2.5 py-1 rounded-md text-xs whitespace-nowrap pointer-events-none z-50 shadow">
              {tool.label}
            </span>
          </button>
        );
      })}

      <div className="mt-auto">
        <button
          onClick={openGenerate}
          title="Skapa med AI (G)"
          className="group relative w-10 h-10 rounded-[9px] flex items-center justify-center text-ai border border-[rgba(167,139,250,0.3)] hover:border-[rgba(167,139,250,0.5)] bg-gradient-to-br from-[rgba(167,139,250,0.18)] to-[rgba(59,130,246,0.1)] hover:from-[rgba(167,139,250,0.3)] hover:to-[rgba(59,130,246,0.18)] hover:scale-105 transition-all"
        >
          <Icon name="sparkles" size={20} />
          <span className="absolute left-[52px] top-1/2 -translate-y-1/2 translate-x-[-4px] opacity-0 group-hover:opacity-100 group-hover:translate-x-0 transition-all bg-bg-elevated border border-border-strong px-2.5 py-1 rounded-md text-xs whitespace-nowrap pointer-events-none z-50 shadow">
            Skapa med AI
          </span>
        </button>
      </div>
    </aside>
  );
}
